import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/exams/interactive/:examId/attempts/:attemptId/questions/`;
const pathById = `${pathBase}::questionId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const examAttemptQuestions = {
  getAll: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
} as const;
